import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../api/axios";
import useAuth from "../hooks/useAuth";
import DataContext from "../components/Datacontext";
import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CFormSelect,
  CFormCheck,
  CFormInput,
} from "@coreui/react";

function Service() {
  const { auth } = useAuth();
  const authToken = auth.access_token;
  const { store_id } = useContext(DataContext);
  const [serviceitems, setServiceItems] = useState([]);
  const apiURL = auth.roles==6099 ? `/services` :`/getallservices/${store_id}`;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(apiURL, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setServiceItems(response.data.Services);
    } catch (error) {
      console.error("Error fetching client list:", error);
    }
  };

  const handleEdit = (index) => {
    // Set the item's editing state to true
    setServiceItems((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, editing: true } : item
      )
    );
  };

  const handleUpdate = async (index) => {
    try {
      const editedItem = serviceitems[index];
      console.log(editedItem);
      // Perform the update request with edited data
     
      if(auth.roles== 6099){
        const newUrl = `/services/update/${editedItem.id}`;
        const newData = {
          service: editedItem.service,
          duration: editedItem.duration,
          visible:editedItem.visible,
          // Add additional properties for role 6099 if needed
        };
        await axios.put(newUrl, newData, {
          headers: {
              Authorization: `Bearer ${authToken}`,
              // Add additional headers for other roles if needed
          },
        });
  
      }else{
        const newUrl = `/store-category/update/${editedItem.sid}`;
        const newData = {         
          duration: editedItem.sduration,
          visible: editedItem.store_visible,
          // Add additional properties for role 6099 if needed
        };
        await axios.put(newUrl, newData, {
          headers: {
              Authorization: `Bearer ${authToken}`,
              // Add additional headers for other roles if needed
          },
        });
  
      }

      
      // Clear the editing state
      setServiceItems((prevItems) =>
        prevItems.map((item, i) => ({ ...item, editing: false }))
      );

      // Refetch data to update the UI
      fetchData();
    } catch (error) {
      console.error("Error updating item:", error);
    }
  };

  const handleCancelEdit = (index) => {
    // Clear the editing state
    setServiceItems((prevItems) =>
      prevItems.map((item, i) => ({ ...item, editing: false }))
    );
  };

  const handleFieldChange = (index, field, value) => {
    // Update the edited field value
    setServiceItems((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );

  };

  const markedChecked=(value)=>{
    console.log(value)
   if (value == "TRUE") {
   return "checked"
   }else{
    return false;
   }

  }
  return (
    <CCard>
      <CCardHeader>
        <div className="d-flex justify-content-between">
          <h3>Service Category</h3>
          <CNav
            component="nav"
            variant="pills"
            className="flex-column flex-sm-row"
          >
            <CNavLink
              active
              color="dark"
              className="btn btn-dark"
              href="/login/serviceadd"
            >
              Add Category
            </CNavLink>
          </CNav>
        </div>
      </CCardHeader>
      <CCardBody>
        <table className="table">
          <thead>
            <tr>
              <th scope="col"> Sno </th>
              <th scope="col"> service </th>
              <th scope="col"> duration </th>
              <th scope="col"> Action </th>
            </tr>
          </thead>
          <tbody>
            {serviceitems && serviceitems.length > 0 ? (
              serviceitems.map((item, index) => (
                <tr key={index}>
                  <th scope="row">
                   
                    {  index + 1}
                  
                  </th>
                  <td>
                    {item.editing && auth.roles== 6099 ? (
                      <CFormInput
                        type="text"
                        value={item.service}
                        onChange={(e) =>
                          handleFieldChange(index, "service", e.target.value)
                        }
                      />
                    ) : (
                      item.service
                    )}
                  </td>
                  <td>
                    {item.editing ? (
                      <CFormInput
                        type="number"
                        placeholder="input in minutes: eg 45"
                        value={auth.roles==6099 ?item.duration :item.sduration}
                        onChange={(e) =>
                          handleFieldChange(index, auth.roles==6099 ?"duration" :"sduration", e.target.value)
                        }
                      />
                    ) : (
                      auth.roles==6099 ?item.duration :item.sduration
                    )}
                  </td>
                  <td>
                    {item.editing ? (
                      <CFormSelect
                        value={auth.roles==6099 ?item.visible :item.store_visible}
                        onChange={(e) =>
                          handleFieldChange(index,auth.roles==6099 ?"visible" :"store_visible", e.target.value)
                        }
                      >
                        
                        <option value="TRUE" >TRUE</option>
                        <option value="FALSE">FALSE</option>
                      </CFormSelect>
                    ) : (
                      auth.roles==6099 ?item.visible :item.store_visible
                    )}
                  </td>
                  <td>
                    {item.editing ? (
                      <>
                        <CButton
                          color="dark"
                          onClick={() => handleUpdate(index)}
                        >
                          Save
                        </CButton>
                        <CButton
                          color="danger"
                          onClick={() => handleCancelEdit(index)}
                        >
                          Cancel
                        </CButton>
                      </>
                    ) : (
                      <CButton
                        color="dark"
                        variant="outline"
                        onClick={() => handleEdit(index)}
                      >
                        Edit
                      </CButton>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <th colSpan={4} scope="row">
                  No record found
                </th>
              </tr>
            )}
          </tbody>
        </table>
      </CCardBody>
    </CCard>
  );
}

export default Service;
